const trapFocusHandlers = {};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function trapFocus(container) {
  removeTrapFocus();
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  let redirectingFocus = false;
  const isExternalModal = (target) => {
    if (!(target instanceof Element)) return false;
    const modal = target.closest('dialog[open], [role="dialog"][aria-modal="true"]');
    return modal && !modal.contains(container);
  };
  trapFocusHandlers.keydown = (event) => {
    if (event.key !== "Tab" || isExternalModal(document.activeElement)) return;
    const activeEl = document.activeElement;
    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first == null ? void 0 : first.focus();
    } else if (event.shiftKey && (activeEl === first || activeEl === container)) {
      event.preventDefault();
      last == null ? void 0 : last.focus();
    }
  };
  trapFocusHandlers.focusin = (event) => {
    if (redirectingFocus || !container.isConnected || isExternalModal(event.target)) return;
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      redirectingFocus = true;
      try {
        first == null ? void 0 : first.focus();
      } finally {
        redirectingFocus = false;
      }
    }
  };
  document.addEventListener("keydown", trapFocusHandlers.keydown, true);
  document.addEventListener("focusin", trapFocusHandlers.focusin, true);
  container.focus();
}
function removeTrapFocus() {
  trapFocusHandlers.keydown && document.removeEventListener("keydown", trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin && document.removeEventListener("focusin", trapFocusHandlers.focusin, true);
}
function cycleFocus(items, increment) {
  const currentIndex = items.findIndex((item) => item.matches(":focus"));
  let targetIndex = currentIndex + increment;
  if (targetIndex >= items.length) {
    targetIndex = 0;
  } else if (targetIndex < 0) {
    targetIndex = items.length - 1;
  }
  const targetItem = items[targetIndex];
  if (!targetItem) return;
  targetItem.focus();
}
export {
  cycleFocus,
  removeTrapFocus,
  trapFocus
};

